import { CheckGreenIcon } from 'ui';
import { type PostType, useHeaderPostImage } from './hooks';

type P = {
  postType: PostType;
  type?: 'checked' | 'selected' | 'unchecked';
};

const HeaderImage = ({ postType, type }: P) => {
  const getHeaderPostImage = useHeaderPostImage();

  switch (type) {
    case 'checked':
    case 'unchecked':
      return <CheckGreenIcon size="middle" type="success" />;
    case 'selected':
      return getHeaderPostImage(postType);
    case undefined:
      return undefined;
    default:
      return undefined;
  }
};

export default HeaderImage;
